
define([
    "dojo/_base/declare",
    "./Observable"
], function (declare, Observable) {

    //noinspection JSUnusedLocalSymbols,FunctionWithInconsistentReturnsJS
    /**
     * Observable interface for peer model objects.
     */
    var PeerEventObservable = declare([Observable], {
        /**
         * Add an event listener for the specified type of event.
         * @param type Type of event to observe.
         * @param callback Observer (can be a string if the scope is specified).
         * @param scope Optional scope to use for the listener.
         */
        addPeerEventListener: function (type, callback, scope) {},

        /**
         * Remove the listener which was added using the exact same type and observer instances.
         * @param type Type of event listener to remove.
         * @param callback Observer used to add the event listener.
         * @param scope Optional scope to use for the listener.
         */
        removePeerEventListener: function (type, callback, scope) {},

        /**
         * Check if a listener has been added.
         * @param type Type of event listener.
         * @param callback Observer used to add the listener.
         * @param scope Optional scope to use for the listener.
         * @return True if the exact same listener (with the same scope) has been added for the
         * specified type of event.
         */
        hasPeerEventListener: function (type, callback, scope) {},

        /**
         * Dispatch a custom event.
         * @param type Type of event listener.
         * @param target The target of the event.
         * @param data The event data.
         * @param originator Optional originator object for this event.
         */
        dispatchPeerEvent: function (type, target, data, originator) {}
    });

    // make the impl available on the exported class
    PeerEventObservable.Impl = declare([Observable.Impl], {

        addPeerEventListener: function (type, callback, scope) {
            var listener = function (event) {
                if (event.data.type && event.data.type === type) {
                    callback.call(scope, event);
                }
            };
            listener.type = type;
            listener.callback = callback;
            listener.scope = scope;
            this.addEventListener("peerEvent", listener);
        },

        hasPeerEventListener: function (type, callback, scope) {
            var peerEventObserver = this._getPeerEventObserver(type, callback, scope);
            return !!peerEventObserver;
        },

        removePeerEventListener: function (type, callback, scope) {
            var peerEventObserver = this._getPeerEventObserver(type, callback, scope);
            if (peerEventObserver) {
                this.removeEventListener("peerEvent", peerEventObserver.callback,
                    peerEventObserver.scope);
            } else {
                throw new Error("Listener does not exist");
            }
        },

        _getPeerEventObserver: function (type, callback, scope) {
            if (this._listeners.peerEvent) {
                return this._listeners.peerEvent.filter(function (listener) {
                    return listener.callback.callback && listener.callback.type === type &&
                        listener.callback.callback === callback &&
                        listener.callback.scope === scope;
                })[0];
            }
            return null;
        },

        dispatchPeerEvent: function (type, target, data, originator) {
            if (!data) {
                data = {};
            }
            data.type = type;
            this.dispatchEvent("peerEvent", target, data, originator);
        }
    });

    return PeerEventObservable;
});
